<template>
  <div class="content">
    <div class="detail-drawer" v-loading="loading">
      <div class="drawer-title" :style="{'line-height': orderForm.orderName.length > 35 ? '' : '53px'}">
        <div class="drawer-title-icon">
          <i class="el-icon-close" @click="handleCloseDraw" style="cursor:pointer"></i>
        </div>
        <div class="drawer-title-header">
          <div class="drawer-title-text">
            <div>
              订单:&nbsp;{{orderForm.orderName}} &nbsp;
              <span style="color:rgba(0,0,0,0.45)">{{orderForm.orderNo}}</span>
            </div>
          </div>
        </div>
      </div>
      <el-tabs
        tab-position="left"
        v-model="activeName"
        style="height: 100%;"
        class="drawer-tabs"
        @tab-click="handleTabClick"
      >
        <el-tab-pane name="detail">
          <span slot="label">
            <i class="el-icon-view"></i> 详情
          </span>
          <div>
            <div class="title-text">基本信息</div>
            <el-form label-width="100px" label-position="left">
              <el-row>
                <el-col>
                  <el-form-item label="广告主">
                    <template v-if="orderForm.adDspPartner">{{orderForm.adDspPartner.partnerName}}</template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="购买方式">{{orderForm.buyType === 0 ? '合约排期':'竞价购买'}}</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="投放时间"
                    v-if="orderForm.contractBeginDate && orderForm.contractEndDate"
                  >{{orderForm.contractBeginDate +'~'+ orderForm.contractEndDate}}</el-form-item>
                   <el-form-item
                    label="投放时间"
                    v-else
                  >-</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                 <el-col :span="12">
                  <el-form-item label="售卖方式">
                   {{totalContractTxt}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="投放总量">{{orderForm.totalContract + orderForm.freeTotalTraffic + orderForm.addedTotalTraffic }}pv</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="排期量">{{orderForm.totalContract}}pv</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="赠送量">{{orderForm.freeTotalTraffic}}pv</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="补量">{{orderForm.addedTotalTraffic}}pv</el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="客户品牌">
                    {{ orderForm.customerBrands && orderForm.customerBrands.length ?  orderForm.customerBrands.join('、') : '-' }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="客户产品">
                    {{ orderForm.customerProducts && orderForm.customerProducts.length ?  orderForm.customerProducts.join('、') : '-' }}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="订单标签">
                        <template v-if="orderForm.orderTag && orderForm.orderTag.length >0">
                  <div v-for="(item,index) in tagsMapList"
                  :key="'t'+index">
                  <el-row>
                    <el-col :span="4">{{item.label}}&nbsp;</el-col>
                    <el-col :span="20">
                      <span v-if="item.children">{{ item.children.join(',') }}</span>
                    </el-col>
                    </el-row>
                  </div>
                </template>
                <template v-else>
                  -
                </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="业务员">
                    <template
                      v-if="orderForm.adSalesmanList && orderForm.adSalesmanList.length !== 0">
                    <span
                      v-for="(item,index) in orderForm.adSalesmanList"
                      :key="item.salesmanId"
                    >
                    <template v-if="index !== orderForm.adSalesmanList.length - 1">{{item.salesmanName}},</template>
                    <template v-else>{{item.salesmanName}}</template></span>
                    </template>
                    <span v-else>-</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="高质量设备">
                    <span :style="{ color: orderForm.ipFilter === 1 ? '#19bf44' : '#666' }">{{ ['关闭', '开启'][orderForm.ipFilter || 0] }}</span>
                  </el-form-item>
                  <el-form-item label="IES服务">
                    <span :style="{ color: orderForm.iesSwitch === 1 ? '#19bf44' : '#666' }">{{ ['关闭', '开启'][orderForm.iesSwitch || 0] }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane name="log">
          <span slot="label">
            <i class="el-icon-date"></i> 日志
          </span>
           <div class="title-text">操作日志</div>
          <Table :props="logTable.props" :header="logTable.header" :data="logTable.data" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  inject: ['projectOrder'],
  data() {
    return {
      activeName: 'detail',
      loading: false,
      logTable: {
        props: {
          height: '600',
          border: true,
          stripe: false,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h('TimeFormat', {
                props: {
                  value: row.createTime
                }
              })
            }
          },
          {
            label: '操作者',
            align: 'left',
            prop: 'operator',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.userType) {
                return params.userType === 1 ? '管理后台' : params.operator
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作类型',
            align: 'left',
            prop: 'operateType',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.operateType || params.operateType === 0) {
                return this.$consts.operateTypeText[params.operateType]
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作内容',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': true
          }

        ],
        data: []
      },
      orderForm: {
        orderName: '',
        partnerId: '',
        dailyBudget: '',
        buyType: '',
        createTime: '',
        contractBeginDate: '',
        contractEndDate: '',
        orderStatus: undefined,
        sellingType: 1,
        customerBrands: [], // 客户品牌
        customerProducts: [] // 客户产品
      },
      tagsMapList: [],
      tagList: []
    }
  },
  props: ['initMode', 'id', 'priceData', 'flage'],
  computed: {
    totalContractTxt() {
      let form = this.orderForm
      let res
      switch (form.sellingType) {
        case 1:
          res = 'CPM'
          break
        case 2:
          res = 'CPC'
          break
        case 3:
          res = 'CPD'
          break
      }
      return res
    }
  },
  methods: {
    handleTabClick() {
      this.handleOrder()
    },
    handleOrder() {
      this.loding = true
    },
    // 获取订单标签
    getOrderTags() {
      return new Promise((resolve, reject) => {
        this.$service.getOrderTags().then(data => {
          this.tagList = data.map(item => {
            return {
              label: item.mediaTagTypeName,
              value: item.mediaTagTypeId,
              isRequired: item.isRequired,
              children: item.mediaTagsList.map(e => {
                return {
                  label: e.mediaTagName,
                  value: item.mediaTagTypeId + '-' + e.mediaTagId // 子级value需要拼接
                }
              })
            }
          })
        })
        resolve()
      })
    },
    getFecthTableData() {
      this.$service.getOrderById({ id: this.id }).then((data) => {
        this.orderForm = JSON.parse(JSON.stringify(data))
        if (data.orderTag) {
          let tagsMap = JSON.parse(JSON.stringify(this.tagList)).reduce((result, item) => {
            result[item.value] = item
            result[item.value].children = []
            return result
          }, {})
          this.tagList.forEach(item => {
            item.children.forEach(e => {
              data.orderTag.split(',').forEach(value => {
                if (value === e.value.split('-')[1]) {
                  tagsMap[item.value].children.push(e.label)
                }
              })
            })
          })
          this.tagsMapList = Object.keys(tagsMap).reduce((result, key) => {
            if (tagsMap[key].children.length > 0) {
              result.push(tagsMap[key])
            }
            return result
          }, [])
        }
        if (data.sellingType === 1) {
          this.orderForm.totalContract = this.orderForm.totalContract * 1
        }
        this.logTable.data = data.orderLogList
        this.loading = false
      })
    },
    handleCloseDraw() {
      this.$emit('handleCloseDraw')
    }
  },
  created() {
    this.mode = this.initMode || 'read'
    this.getOrderTags().then(data => {
      this.getFecthTableData()
    })
    this.loading = true
    this.activeName = this.flage === 1 ? 'detail' : 'log'
  }
}
</script>
<style lang="stylus" scoped>
.child-label-text {
  padding-right: 10px;
  color: #999;
}
.content {
  display: flex;
  flex-direction: column;
}

.detail-drawer {
  height: inherit;
}

.drawer-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 53px;
  // line-height: 53px;
}

.drawer-title-icon {
  width: 56px;
  text-align: center;
  height: inherit;
  background: rgba(10, 33, 64, 0.831372549019608);
  color: #fff;
  height: 53px;
  line-height: 53px;
}

.drawer-title-header {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 56px);
}

.drawer-title-text {
  height: inherit;
  padding: 0px 16px;
  font-size: 14px;
}

// .drawer-title-text-tootip {
// white-space: nowrap;
// display: flex;
// }
.title-text-tootip-first-title, .title-text-tootip-second-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.title-text-tootip-first-title {
  color: rgba(0, 0, 0, 0.65);
  max-width: 230px;
}

.title-text-tootip-second-title {
  max-width: 300px;
}

.drawer-operate {
  display: flex;
  align-items: center;
  width: calc(100% - 630px);
  justify-content: flex-end;
  padding-right: 20px;
}

.drawer-tabs> >>>.el-tabs__header {
  margin: 0;
  padding: 0;
  width: 55px;
  border-bottom: none;
}

.drawer-tabs> >>>.el-tabs__content {
  border-top: 1px solid #f0f2f5;
  border-left: 1px solid #f0f2f5;
  height: calc(100vh - 60px);
  overflow: auto;
  padding: 0 16px;
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__active-bar {
  display: none;
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item {
  padding: 0 !important;
  height 53px
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item.is-active {
  background-color: #ff8b00;
  color: #fff;
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item :hover {
  color: rgba(0, 0, 0, 0.65);
}

.drawer-tabs> >>>.el-tabs__header .el-tabs__item span {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 56px;
  height 53px
  line-height: 2;
  font-weight: bold;
}

.drawer-tabs> >>>.tab-left {
  width: 100%;
  display: flex;
  height: 100%;
}

.cc-tabs {
  width: 100%;
}

.cc-tabs>>>.el-tabs__nav-wrap:after {
  content: none !important;
}

.cc-tabs {
  >>>.el-tabs__nav {
    width: 100%;
  }

  >>>.el-tabs__item {
    line-height: 53px;
    width: auto !important;
    padding: 0 20px;
  }

  >>>.el-tabs__active-bar {
    width: 56px !important;
  }
}
.table-tabs-detail >>>.el-tabs__item span
    font-size: 14px;
    display: block;
    width: 96px;
    height: 53px;
    line-height: 53px;

.cc-operation-area {
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  height: 53px;
  line-height: 53px;
  padding: 0 16px;
}

>>>.el-form-item {
  margin-bottom: 0px;
}
</style>
